export interface IEnvWindow extends Window {
  REACT_APP_ADMIN__CONFIGURATION_KSDO_API_URL: string;
  REACT_APP_SERVER_URL: string;
  REACT_APP_AUTHORITY_URL: string;
  REACT_APP_ADMIN_API_URL: string;
  REACT_APP_ADMIN__ADMIN_API_URL: string;
  REACT_APP_ADMIN__FLAGS_API_URL: string;
  REACT_APP_ADMIN__ANNOTATIONS_API_URL: string;
  REACT_APP_ADMIN__CONFIGURATION_API_API_URL: string;
  REACT_APP_ADMIN__SPECIAL_CASE_DEFINITION_API_URL: string;
  REACT_APP_ADMIN__LABELS_URL: string;
  REACT_APP_COMMUNICATION_API_URL: string;
  REACT_APP_COMMUNICATION__FOLDER_URL: string;
  REACT_APP_COMMUNICATION__MESSAGE_URL: string;
  REACT_APP_COMMUNICATION__CONVERSATION_URL: string;
  REACT_APP_DISTRIBUTION_API_URL: string;
  REACT_APP_DISTRIBUTION__EXAM_TASK_GROUP_API_URL: string;
  REACT_APP_DISTRIBUTION__EXAM_TASK_GROUP_SOLUTION_API_URL: string;
  REACT_APP_EXAMINERS_API_URL: string;
  REACT_APP_EXAMS_API_URL: string;
  REACT_APP_EXAMS__ASSESSMENT_SESSION_API_URL: string;
  REACT_APP_EXAMS__EXAMINING_TEAM_API_URL: string;
  REACT_APP_EXAMS__EXAM_SESSION_API_URL: string;
  REACT_APP_EXAMS__EXAM_TASK_GROUP_COORINDATOR_API_URL: string;
  REACT_APP_EXAMS__EXAM_GRADE_RULE_API_URL: string;
  REACT_APP_EXAMS__SAMPLE_ASSESSMENT_GROUP_API_URL: string;
  REACT_APP_EXAMS__VERIFICATION_API_URL: string;
  REACT_APP_EXAMS__EXAM_SCORING_SCHEMA_API_URL: string;
  REACT_APP_IMAGES_API_URL: string;
  REACT_APP_IMAGES__EXAM_SHEET_API_URL: string;
  REACT_APP_IMAGES__EXAM_TASK_API_URL: string;
  REACT_APP_IMAGES__EXAM_SCORING_SCHEMA_API_URL: string;
  REACT_APP_IMAGES__EXAMINEE_API_URL: string;
  REACT_APP_IMAGES__TASK_IMAGE_ZONE_API_URL: string;
  REACT_APP_IMAGES__TASKS_SOLUTION_SHEET_API_URL: string;
  REACT_APP_WEBSOCKET_URL: string;
  REACT_APP_NOTIFICATIONS_API_URL: string;
  REACT_APP_NOTIFICATIONS__NOTIFICATION_API_URL: string;
  REACT_APP_SCANS_URL: string;
  REACT_APP_SCORING_API_URL: string;
  REACT_APP_SCORING__EXAM_TASK_GROUP_SOLUTION_API_URL: string;
  REACT_APP_SCORING__EXAM_TASK_GROUP_SOLUTION_SCORE_API_URL: string;
  REACT_APP_SCORING__ANNOTATION_API_URL: string;
  REACT_APP_SCORING__WEBSOCKET_URL: string;
  REACT_APP_SCORING_MODEL_API_URL: string;
  REACT_APP_SCORING_MODEL__EXAM_TASK_GROUP_SOLUTION_SCORE_API_URL: string;
  REACT_APP_SCORING_MODEL__ASSESSMENT_SESSION_API_URL: string;
  REACT_APP_EVALUATION_API_URL: string;
  REACT_APP_EVALUATION_API_URL__EXAMINER_QUALITY_API_URL: string;
  REACT_APP_USERS_API_URL: string;
  REACT_APP_ROLES_API_URL: string;
  REACT_APP_TRANSLATIONS_URL: string;
  REACT_APP_LABELS_URL: string;
  REACT_APP_POST_LOGOUT_REDIRECT_URL: string;
  REACT_APP_REDIRECT_URL: string;
  REACT_APP_SILENT_URL: string;
  REACT_APP_APPINSIGHTS_CONNECTION_STRING: string;
  REACT_APP_APPINSIGHTS_DISABLED: boolean;
  REACT_APP_DXC_ENV: boolean;
  REACT_APP_SUPPORT_API_URL: string;
  REACT_APP_SUPPORT_PDF_API_URL: string;
  REACT_APP_SUPPORT_MOVIE_API_URL: string;
  REACT_APP_RESULTS_API_URL: string;
  REACT_APP_CALENDAR_API_URL: string;
  REACT_APP_FINANCE_API_URL: string;
  REACT_APP_REPORTS_URL: string;
}

const EnvWindow: IEnvWindow = window as unknown as IEnvWindow;
export default EnvWindow;
